export default "__VITE_ASSET__1836615c__"